import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

function ModalQuestionToPDF({ show, onHide, submit }) {
  const [val, setVal] = useState(false);
  function handleChangeKeyStatus(status) {
    setVal(status);
  }
  function onShow() {
    setVal(false);
  }
  function handleOnHide() {
    onHide();
    setVal(false);
  }
  return (
    <>
      <Modal show={show} onHide={handleOnHide} onShow={onShow}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Generate PDF</h5>
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <div className="form-check mb-3">
              <input onChange={() => handleChangeKeyStatus(false)} className="form-check-input" type="radio" name="key" defaultChecked />
              <label className="form-check-label" htmlFor="defaultRadio1">
                Without key
              </label>
            </div>
            <div className="form-check">
              <input onChange={() => handleChangeKeyStatus(true)} className="form-check-input" type="radio" name="key" />
              <label className="form-check-label" htmlFor="defaultRadio1">
                With key
              </label>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button onClick={() => submit(val)} type="button" className="btn btn-outline-theme">
            Generate
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalQuestionToPDF;
